// @flow
import type {Element} from 'react'
import React, {useEffect, useState} from 'react'
import classNames from 'classnames'

import styles from './index.scss'

function OfflineBanner(): null | Element<"div"> {
  const [isOnline, setIsOnline] = useState(navigator.onLine)

  useEffect(() => {
    const updateOnlineStatus = () => setIsOnline(navigator.onLine)

    window.addEventListener('online', updateOnlineStatus)
    window.addEventListener('offline', updateOnlineStatus)

    return () => {
      window.removeEventListener('online', updateOnlineStatus)
      window.removeEventListener('offline', updateOnlineStatus)
    }
  })

  if (isOnline)
    return null

  const bannerClassName = classNames('banner', styles.offlineBanner)

  return (
    <div
      aria-label={I18n.t('error.connection_offline')}
      className={bannerClassName}
      role="region"
    >
      <div className="banner__content">
        <span className="banner__content-caption">
          <span className="banner__content-caption-icon">
            <i className="fa-solid fa-wifi" />
          </span>
          <span className="banner__content-caption-text">
            {I18n.t('error.connection_offline')}
          </span>
        </span>
      </div>
    </div>
  )
}

export default OfflineBanner
